













































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteFeedbackStore from '@/components/Suporte/Store/SuporteFeedbackStore'

@Component

export default class ViewSuporteFeedback extends Vue {
  loadingPerguntas: boolean = false

  loadingRespostas: boolean = false

  salvando: boolean = false

  dialogPergunta: boolean = false

  dialogResultados: boolean = false

  dialogJson: boolean = false

  searchAvaliacao: string = ''

  form: any = this.formVazio()

  perguntaHeaders: any[] = [
    { text: 'Texto', value: 'texto', align: 'left' },
    { text: 'Início', value: 'dataInicio', align: 'center' },
    { text: 'Fim', value: 'dataFim', align: 'center' },
    { text: 'Status', value: 'status', align: 'center', sortable: false },
    { text: 'Ações', value: 'acoes', align: 'center', sortable: false },
  ]

  avaliacaoHeaders: any[] = [
    { text: 'Nota', value: 'nota', align: 'center' },
    { text: 'Comentário', value: 'texto', align: 'left' },
    { text: 'Usuário', value: 'usuarioNome', align: 'left' },
    { text: 'Login', value: 'usuarioLogin', align: 'left' },
    { text: 'Tipo', value: 'tipoUsuario', align: 'left' },
    { text: 'Hospitais', value: 'hospitais', align: 'left', sortable: false },
  ]

  tiposDeUsuarioItems: any[] = [
    { text: 'Médico', value: 'Medico' },
    { text: 'Secretária do médico', value: 'SecretariaDoMedico' },
    { text: 'Secretária do ambulatório', value: 'SecretariaDoAmbulatorio' },
    { text: 'Secretária do agendamento', value: 'SecretariaDoAgendamento' },
    { text: 'Usuário backoffice', value: 'UsuarioBackoffice' },
    { text: 'Backoffice cadastro médico/remuneração', value: 'UsuarioBackofficeCadastroMedicoRemuneracao' },
    { text: 'Operadora', value: 'Operadora' },
  ]

  get getSuporteFeedbackStore() {
    return getModule(SuporteFeedbackStore, this.$store)
  }

  get respostas() {
    return this.getSuporteFeedbackStore.respostas
  }

  get jsonDoRetorno() {
    return this.respostas ? JSON.stringify(this.respostas, null, 2) : ''
  }

  async copiarJson() {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(this.jsonDoRetorno)
      } else {
        const textarea = document.createElement('textarea')
        textarea.value = this.jsonDoRetorno
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
      }
      EventBus.$emit('setSnackbar', { show: true, text: 'JSON copiado!', icon: 'done', color: '#2E7D32' })
    } catch {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível copiar o JSON.', icon: 'warning', color: '#C62828' })
    }
  }

  get avaliacoesFiltradas() {
    const avaliacoes = (this.respostas && this.respostas.avaliacoes) || []
    const busca = (this.searchAvaliacao || '').toLowerCase().trim()
    if (!busca) return avaliacoes

    return avaliacoes.filter((a: any) =>
      [a.usuarioNome, a.usuarioLogin, a.tipoUsuario, a.texto, ...(a.hospitais || [])]
        .some((campo: any) => String(campo || '').toLowerCase().includes(busca)))
  }

  get respostasPorTipo() {
    const porTipo: Record<string, { tipo: string; promotores: number; neutros: number; detratores: number; total: number }> = {}

    this.avaliacoesFiltradas.forEach((a: any) => {
      const tipo = a.tipoUsuario || '—'
      if (!porTipo[tipo]) porTipo[tipo] = { tipo, promotores: 0, neutros: 0, detratores: 0, total: 0 }
      porTipo[tipo].total += 1
      if (a.nota > 8) porTipo[tipo].promotores += 1
      else if (a.nota >= 7) porTipo[tipo].neutros += 1
      else porTipo[tipo].detratores += 1
    })

    return Object.values(porTipo).sort((a, b) => b.total - a.total)
  }

  pct(parte: number, total: number) {
    return total ? `${(parte / total) * 100}%` : '0%'
  }

  get distribuicaoDeNotas() {
    const avaliacoes = this.avaliacoesFiltradas
    const contagem = Array.from({ length: 11 }, (_, nota) => ({
      nota,
      total: avaliacoes.filter((a: any) => a.nota === nota).length,
    }))
    const maior = Math.max(1, ...contagem.map(c => c.total))
    return contagem.map(c => ({
      ...c,
      altura: c.total ? Math.max(4, Math.round((c.total / maior) * 120)) : 0,
      cor: c.nota > 8 ? '#2E7D32' : c.nota >= 7 ? '#F9A825' : '#C62828',
    }))
  }

  get rankingHospitais() {
    const avaliacoes = this.avaliacoesFiltradas
    const porHospital: Record<string, { nome: string; promotores: number; detratores: number }> = {}

    avaliacoes.forEach((a: any) => {
      const nomes = [...new Set((a.hospitais || []) as string[])]
      nomes.forEach(nome => {
        if (!porHospital[nome]) porHospital[nome] = { nome, promotores: 0, detratores: 0 }
        if (a.nota > 8) porHospital[nome].promotores += 1
        else if (a.nota < 7) porHospital[nome].detratores += 1
      })
    })

    return Object.values(porHospital)
  }

  get hospitaisQueMaisPromoveram() {
    return this.rankingHospitais
      .filter(h => h.promotores > 0)
      .sort((a, b) => b.promotores - a.promotores)
      .slice(0, 5)
  }

  get hospitaisQueMaisDetrataram() {
    return this.rankingHospitais
      .filter(h => h.detratores > 0)
      .sort((a, b) => b.detratores - a.detratores)
      .slice(0, 5)
  }

  baixarJson() {
    const blob = new Blob([this.jsonDoRetorno], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `respostas-feedback-${new Date().toISOString().substring(0, 10)}.json`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  get segmentosNPS() {
    if (!this.respostas) return []
    return [
      { label: 'Geral', dados: this.respostas.nps },
      { label: 'Médico', dados: this.respostas.medicoNPS },
      { label: 'Secretária do médico', dados: this.respostas.secretariaDoMedicoNPS },
      { label: 'Backoffice', dados: this.respostas.backofficeNPS },
      { label: 'Secretária do agendamento', dados: this.respostas.secretariaDoAgendamentoNPS },
      { label: 'Secretária do ambulatório', dados: this.respostas.secretariaDoAmbulatorioNPS },
    ].filter(s => s.dados)
  }

  formVazio() {
    return {
      id: null,
      texto: 'De 0 a 10, qual a probabilidade de você recomendar a Fin-X para um amigo ou colega?',
      dataInicio: '',
      dataFim: '',
      tiposDeUsuario: [
        'Medico',
        'SecretariaDoMedico',
        'SecretariaDoAmbulatorio',
        'SecretariaDoAgendamento',
        'UsuarioBackoffice',
        'UsuarioBackofficeCadastroMedicoRemuneracao',
        'Operadora',
      ],
      limiteDeTentativasDeColetaDeFeedback: 5,
      permiteMultiplasRespostas: false,
    }
  }

  formataData(data: string) {
    if (!data) return '—'
    const d = new Date(data)
    const pad = (n: number) => String(n).padStart(2, '0')
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
  }

  paraDatetimeLocal(data: string) {
    if (!data) return ''
    const d = new Date(data)
    const pad = (n: number) => String(n).padStart(2, '0')
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
  }

  statusDaPergunta(pergunta: any) {
    const agora = new Date().toISOString()
    if (pergunta.dataFim < agora) return { label: 'Encerrada', color: 'grey' }
    if (pergunta.dataInicio > agora) return { label: 'Agendada', color: '#F9A825' }
    return { label: 'Ativa', color: '#2E7D32' }
  }

  novaPergunta() {
    this.form = this.formVazio()
    this.dialogPergunta = true
  }

  editarPergunta(pergunta: any) {
    this.form = {
      id: pergunta.id,
      texto: pergunta.texto,
      dataInicio: this.paraDatetimeLocal(pergunta.dataInicio),
      dataFim: this.paraDatetimeLocal(pergunta.dataFim),
      tiposDeUsuario: [...(pergunta.tiposDeUsuario || [])],
      limiteDeTentativasDeColetaDeFeedback: pergunta.limiteDeTentativasDeColetaDeFeedback,
      permiteMultiplasRespostas: pergunta.permiteMultiplasRespostas,
    }
    this.dialogPergunta = true
  }

  async salvarPergunta() {
    if (!this.form.texto || !this.form.dataInicio || !this.form.dataFim || !this.form.tiposDeUsuario.length) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Preencha texto, datas e ao menos um tipo de usuário.', icon: 'warning', color: '#C62828' })
      return
    }

    this.salvando = true
    const payload = {
      ...this.form,
      dataInicio: new Date(this.form.dataInicio).toISOString(),
      dataFim: new Date(this.form.dataFim).toISOString(),
    }
    const request = await this.getSuporteFeedbackStore.upsertPergunta(payload)
    this.salvando = false

    if (request.success) {
      this.dialogPergunta = false
      EventBus.$emit('setSnackbar', { show: true, text: 'Pergunta salva com sucesso!', icon: 'done', color: '#2E7D32' })
      this.fetchPerguntas()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Erro ao salvar a pergunta.', icon: 'warning', color: '#C62828' })
    }
  }

  async verResultados(pergunta: any) {
    this.dialogResultados = true
    this.loadingRespostas = true
    this.getSuporteFeedbackStore.clearRespostas()
    const request = await this.getSuporteFeedbackStore.fetchRespostas(pergunta.id)
    this.loadingRespostas = false

    if (!request.success) {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Erro ao buscar os resultados.', icon: 'warning', color: '#C62828' })
      this.dialogResultados = false
    }
  }

  async fetchPerguntas() {
    this.loadingPerguntas = true
    const request = await this.getSuporteFeedbackStore.fetchPerguntas()
    this.loadingPerguntas = false

    if (!request.success) {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Erro ao buscar as perguntas.', icon: 'warning', color: '#C62828' })
    }
  }

  mounted() {
    this.fetchPerguntas()
  }
}
